module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/training-certificate/training-certificate-form/training-certificate-form.component.html
// module id = ./src/app/pages/functions/training-certificate/training-certificate-form/training-certificate-form.component.html
// module chunks = main